<div *ngIf="loaderService.isLoading$ | async" class="loader-overlay fixed inset-0 flex items-center justify-center z-50">
	<mat-spinner diameter="30"></mat-spinner>
</div>